import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGovBuilding = () => {
  return (
    <g>
      <path d="m1.0078 6.1713h1.8522v5.49h-.3922a.7.7 0 0 0 0 1.4h11.0644a.7.7 0 0 0 0-1.4h-.3922v-5.49h1.8525a.7.7 0 0 0 .3506-1.3057l-6.9925-4.0522a.6977.6977 0 0 0 -.7012 0l-6.9922 4.0522a.7.7 0 0 0 .3506 1.3057zm3.2529 0h1.5593v5.49h-1.56zm4.52 0v5.49h-1.56v-5.49zm2.959 5.49h-1.559v-5.49h1.5586zm-3.7397-9.4334 4.3887 2.543h-8.7774z" />
      <path d="m15.083 13.8807h-14.166a.7.7 0 0 0 0 1.4h14.166a.7.7 0 1 0 0-1.4z" />
    </g>
  );
};

export default withIcon(IconGovBuilding);
